import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from '../api/client'
import { notifyUnauthorized } from '../api/auth-events'

// Zentrales Fehler-Handling: JEDER 401 (egal ob Query oder Mutation) führt über genau eine Stelle
// zum Auth-Reset (#1). Andere Fehler reicht TanStack Query an die jeweilige Komponente weiter.
function onError(error: unknown): void {
  if (error instanceof ApiError && error.status === 401) notifyUnauthorized()
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
    defaultOptions: {
      queries: {
        // KEIN blindes Polling (#4): Focus-Refetch + gezielte Invalidierung tragen die Aktualität.
        refetchOnWindowFocus: true,
        staleTime: 30_000,
        // Offline-Start (Simon, 08.07.2026): der erste Versuch feuert IMMER, auch wenn der Browser
        // offline meldet — der Service Worker (public/sw.js) beantwortet GET /api/* dann aus dem
        // Cache. Der Default 'online' würde die Queries pausieren und die App bliebe im Ladezustand,
        // obwohl der letzte Stand lokal liegt. Retries pausieren offline weiterhin.
        networkMode: 'offlineFirst',
        // API-Fehler (401/403/409 …) NICHT wiederholen; nur echte Netzfehler einmal.
        retry: (count, error) => !(error instanceof ApiError) && count < 1,
      },
    },
  })
}
